import {Modal} from "antd";
import React from "react";
export const InformCloseCourierRequestModal = ({
    visibility,
    onCancel = () => {},
    confirmLoading = false,
    onOkFunc = () => {}
}) => {
    return (
        <Modal
            title={"Kurye Talebinin Kapatılması"}
            visible={visibility}
            onCancel={onCancel}
            confirmLoading={confirmLoading}
            centered
            okText="Onayla"
            onOk={onOkFunc}
            cancelText="İptal"
        >
            <div>
                <p>
                    Alt firma için, bulunduğu bölgede, aktif bir kurye işe alım talebi
                    bulunmaktadır.
                    <br />
                    Onayladığınızda, bu talep otomatik olarak kapatılacaktır.
                    <br />
                    Lütfen bölge müdürü ile iletişime geçiniz.
                </p>
            </div>
        </Modal>
    );
};
